/**
 * Created by jonas on 2021-04-01.
 */
import {BS2} from "../BS2";


export class SpriteUtils {

    public static makeWithTexture(texture?:PIXI.Texture, position:PIXI.Point = new PIXI.Point(0, 0), anchor:PIXI.Point = new PIXI.Point(0, 0), alpha:number = 1, tint:number = 0xffffff):PIXI.Sprite {
        const sprite = new PIXI.Sprite(texture);
        sprite.position.set(position.x, position.y);
        sprite.anchor.set(anchor.x, anchor.y);
        sprite.alpha = alpha;
        sprite.tint = tint;
        return sprite;
    }

    public static make(textureName:string, position:PIXI.Point = new PIXI.Point(0, 0), anchor:PIXI.Point = new PIXI.Point(0, 0), alpha:number = 1, tint:number = 0xffffff):PIXI.Sprite {
        const sprite = new PIXI.Sprite(BS2.assetLoader.getTextures(textureName)[0]);
        sprite.position.set(position.x, position.y);
        sprite.anchor.set(anchor.x, anchor.y);
        sprite.alpha = alpha;
        sprite.tint = tint;
        return sprite;
    }

}